var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQyvoStandaloneLogoMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 108,
    viewBox: "0 0 100 108",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9287 97.2515C87.4595 98.01 88.5038 98.1946 89.2617 97.6636C90.0196 97.1323 90.2042 96.0865 89.6738 95.3276L79.6172 80.9497L87.8262 75.1948L97.8828 89.5728C101.589 94.8708 100.301 102.173 95.0088 105.882C89.7168 109.591 82.424 108.303 78.7188 103.006L62.7441 80.1694C65.7075 78.5735 68.4592 76.6361 70.9492 74.4106L86.9287 97.2515Z",
    fill: "#FFC233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5942 6.20575e-07C66.1183 1.47528e-05 85.1884 19.0905 85.1884 42.6399C85.1884 66.1892 66.1183 85.2797 42.5942 85.2797C19.0701 85.2797 -9.73361e-07 66.1892 -6.2705e-07 42.6399C-2.8074e-07 19.0905 19.0701 2.77841e-07 42.5942 6.20575e-07ZM42.5942 10.0329C24.6049 10.0329 10.0213 24.6321 10.0213 42.6407C10.0215 60.6491 24.605 75.2476 42.5942 75.2476C60.5833 75.2476 75.166 60.6491 75.1662 42.6407C75.1662 24.6321 60.5834 10.033 42.5942 10.0329Z",
    fill: "#F25C3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8601 53.6709C32.9451 62.3705 44.9229 64.4847 53.6132 58.3932C58.0968 55.2504 60.8278 50.5463 61.5887 45.5166L71.4973 47.0194C70.3428 54.6504 66.1833 61.83 59.3617 66.6117C46.1373 75.8813 27.9102 72.6641 18.6504 59.4255L26.8601 53.6709Z",
    fill: "#FFC233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQyvoStandaloneLogoMd);
export default __webpack_public_path__ + "static/media/qyvo-standalone-logo-md.2288d7d1571e7d4f03e791920cb2d4d5.svg";
export { ForwardRef as ReactComponent };